import { useEffect, useState } from 'react';
import { Oval } from "react-loader-spinner";
import logo from '../../assets/images/Logo-white.png';
import { user } from '../../classes/user';
import BoxAlert from '../../components/boxAlert';
import { useAuth } from '../../hooks/useAuth';
import axios from '../../services/axios-config';
import styles from './css/signIn.module.css';


export default function SignIn() {

    const {login} = useAuth();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [alert, setAlert] = useState({show: false, title: null, text: null});


    // FUNCTIONS
    useEffect(() => localStorage.removeItem('auth'), [])


    const handleSignIn = async () => {
        try{
            setLoading(true);

            if(!email || !password){
                setAlert({show: true, title: 'Campos vazios', text: 'Preencha todos os campos para continuar!'});
                return;
            }

            const res = await axios.get(`/admin/login`, {
                params: {
                    email: email,
                    password: password
                }
            }) 

            if(res.status == 200){
                localStorage.setItem('admin_token', res.data.token);
                user.insert(res.data.user);
                login();
            }

        } catch (error) {
            console.error('ERROR - SIGNIN FUNCTION:', error);
            setAlert({show: true, title: 'Erro', text: error?.response?.data?.error});
        
        } finally {
            setLoading(false);
        }

    }




    // SCREEN

    return (

        <div id={styles.screen}>
            <div id={styles.logoImageArea}>
                <img src={logo} className={styles.imageLogo}/>
            </div>

            <div id={styles.container}>
                <div className={styles.bannerArea}></div>

                <div id={styles.loginArea}>
                    <div className={styles.loginDialog}>
                        <div className={styles.formArea}>
                            <h1 style={{fontSize: 25, fontWeight: 700}}>Login</h1>

                            <p style={{fontSize: 13, marginTop: 20}}>Utilize seu login de administrador para acessar o painel SofChef!</p>

                            <div className={styles.inputArea}>
                                <h2 htmlFor="email" className={styles.formLabel}>Email</h2>
                                <input type="email" id="email" value={email} placeholder="Email" className={styles.formInput} onChange={({target: {value}}) => setEmail(value)}/>  
                            </div>

                            <div className={styles.inputArea}>
                                <h2 htmlFor="password" className={styles.formLabel}>Senha</h2>
                                <input type="password" id="password" value={password} placeholder="Senha" className={styles.formInput} onChange={({target: {value}}) => setPassword(value)}/>  
                            </div>

                            <button className={styles.formButton} onClick={() => handleSignIn()}>
                                {loading ? (
                                    <Oval
                                        visible={true}
                                        height="25"
                                        width="25"
                                        color="#fff"
                                        ariaLabel="oval-loading"
                                    />
                                    
                                ) : (
                                    <span style={{color: '#fff'}}>Entrar</span>
                                )}
                            </button>
                        </div>
                        
                    </div>

                </div>


                <div className={styles.explainArea}>
                    <p style={{fontSize: 13, marginTop: 20}}>Realize o login com sua conta de administrador SofChef para que você possa acessar o painel.</p>
                </div>
            </div>

            <BoxAlert
                show={alert.show}
                title={alert.title}
                text={alert.text}
                onClose={() => setAlert({show: false, title: null, text: null})}
            />


        </div>
    )
}